import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Img, DemoAction } from "./shared";

const ROOMS = [
  { k: "hotel1", t: "Zimmer Stein", d: "Natursteinwand, Schreibplatz, 24 m²" },
  { k: "hotel3", t: "Salon-Suite", d: "Eigener Salon, Erker, 42 m²" },
  { k: "hotel4", t: "Gewölbezimmer", d: "Historisches Gewölbe, Gartenblick, 30 m²" },
  { k: "hotel2", t: "Bar & Lounge", d: "Abends geöffnet für Hausgäste" },
];

export default function Hotel({ wide, onCta }) {
  const [i, setI] = useState(0);
  const go = (d) => setI((v) => (v + d + ROOMS.length) % ROOMS.length);
  return (
    <div className="bg-[#EFE9E1] text-[#2B2620]" style={{ fontFamily: "'Bodoni Moda Variable', serif" }}>
      <section className={`relative ${wide ? "h-[600px]" : "h-[560px]"}`}>
        <Img k="hotel1" alt="Hotelzimmer" />
        <div className="absolute inset-0 bg-black/25" />
        <header className="absolute inset-x-0 top-0 pt-12 text-center text-white" style={wide ? { paddingTop: 30 } : undefined}>
          <span className="text-[13px] uppercase tracking-[0.5em]">Haus Alma</span>
        </header>
        <div className="absolute inset-x-0 bottom-12 px-6 text-center text-white">
          <h1 className={`italic leading-[1.05] ${wide ? "text-[64px]" : "text-[42px]"}`}>Ankommen.<br />Durchatmen.</h1>
          <p className="mt-3 text-[12px] uppercase tracking-[0.3em]" style={{ fontFamily: "'DM Sans Variable', sans-serif" }}>Boutique-Hotel · 14 Zimmer (fiktiv)</p>
        </div>
      </section>
      <section className={wide ? "px-14 py-16" : "px-5 py-12"}>
        <div className="flex items-end justify-between">
          <h2 className="text-[30px] italic">Zimmer & Suiten</h2>
          <div className="flex gap-2">
            <button type="button" data-noswipe aria-label="Vorheriges Zimmer" onClick={() => go(-1)} className="grid h-10 w-10 place-items-center rounded-full border border-[#2B2620]/30"><ChevronLeft className="h-4 w-4" /></button>
            <button type="button" data-noswipe aria-label="Nächstes Zimmer" onClick={() => go(1)} className="grid h-10 w-10 place-items-center rounded-full border border-[#2B2620]/30"><ChevronRight className="h-4 w-4" /></button>
          </div>
        </div>
        <div className={`relative mt-6 overflow-hidden ${wide ? "h-[420px]" : "h-[300px]"}`}>
          {ROOMS.map((r, j) => (
            <div key={r.k} className="absolute inset-0 transition-opacity duration-700" style={{ opacity: j === i ? 1 : 0 }} aria-hidden={j !== i}>
              <Img k={r.k} alt={r.t} />
            </div>
          ))}
        </div>
        <div className="mt-5 flex items-baseline justify-between gap-4" style={{ fontFamily: "'DM Sans Variable', sans-serif" }}>
          <div><p className="text-[20px]" style={{ fontFamily: "'Bodoni Moda Variable', serif" }}>{ROOMS[i].t}</p><p className="text-[13px] text-[#6A6157]">{ROOMS[i].d}</p></div>
          <span className="text-[12px] tracking-widest">{i + 1} / {ROOMS.length}</span>
        </div>
        <DemoAction label="Verfügbarkeit prüfen" onCta={onCta} className="mt-8 w-full border border-[#2B2620] py-4 text-[12px] uppercase tracking-[0.3em]" style={{ fontFamily: "'DM Sans Variable', sans-serif" }} />
      </section>
    </div>
  );
}
